module.exports = __webpack_public_path__ + "h5/img/djs.18740d97.png";